import * as React from 'react';

const ContactFormIcon = ({fillColor = '#2D2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={15} height={15}>
    <path
      fill={fillColor}
      d="M11.84 14.4H2.818A2.794 2.794 0 0 1 0 11.63V2.768A2.796 2.796 0 0 1 2.818 0h9.021a2.794 2.794 0 0 1 2.819 2.768v8.863A2.794 2.794 0 0 1 11.84 14.4ZM2.818 1.106a1.68 1.68 0 0 0-1.693 1.66v8.864a1.677 1.677 0 0 0 1.691 1.661h9.022c.448.003.88-.172 1.2-.486a1.644 1.644 0 0 0 .494-1.176V2.768a1.677 1.677 0 0 0-1.691-1.662l-9.023.001Z"
    />
    <path
      fill={fillColor}
      d="M2.838 11a.57.57 0 0 1 .57-.57h3.27a.57.57 0 1 1 0 1.14H3.4a.571.571 0 0 1-.562-.57ZM2.838 3.4a.57.57 0 0 1 .57-.572h7.86a.57.57 0 0 1 0 1.141H3.4a.57.57 0 0 1-.562-.57ZM2.838 5.933a.57.57 0 0 1 .57-.57h7.86a.57.57 0 1 1 0 1.125H3.4a.57.57 0 0 1-.562-.555ZM2.838 8.468a.57.57 0 0 1 .57-.57h7.86a.57.57 0 1 1 0 1.125H3.4a.57.57 0 0 1-.562-.555Z"
    />
  </svg>
);

export default ContactFormIcon;
